import {useApi} from "~/composables/api/utils/useApi"

export const useProductApi = () => ({
  async getList(limit = 10, sorts = '', filters = {}) {
    let sortParam = sorts ? `&sort=${sorts}` : ''
    let filterParam = ''

    for (const prop in filters) {
      if (filters[prop]) {
        filterParam += `&filter[${prop}]=${filters[prop]}`
      }
    }
    const url = `products?limit=${limit}${sortParam}${filterParam}`
    const api = useApi()

    return await api.makeRequest(url, 'get')
  },
  async getProfessionalList(token, sort = 'title', filters = {}) {
    const api = useApi()
    let filterParam = ''

    for (const prop in filters) {
      if (filters[prop]) {
        filterParam += `&filter[${prop}]=${filters[prop]}`
      }
    }

    const url = `products?sort=${sort}${filterParam}`
    const config = token ? {headers: {Authorization: `Bearer ${token}`}} : {}

    try {
      return await api.makeRequest(url, 'get', null, config)
    } catch (err) {
      throw err
    }
  },

  async getBySlug(slug, token = null) {
    const url = `products/${slug}`
    const api = useApi()
    const config = token ? {headers: {Authorization: `Bearer ${token}`}} : {}

    try {
      return await api.makeRequest(url, 'get', null, config)
    } catch (err) {
      throw err
    }
  },

  async getListByCategorySlug(categorySlug, sorts = '', filters = {}) {
    let sortParam = sorts ? `&sort=${sorts}` : ''
    let filterParam = ''

    for (const prop in filters) {
      if (filters[prop]) {
        filterParam += `&filter[${prop}]=${filters[prop]}`
      }
    }

    const url = `products?filter[category.slug]=${categorySlug}${filterParam}${sortParam}`
    const api = useApi()

    try {
      return await api.makeRequest(url, 'get')
    } catch (err) {
      throw err
    }
  },

  async getCollectionListByCategorySlug(categorySlug, sorts = '', filters = {}) {
    let sortParam = sorts ? `&sort=${sorts}` : ''
    let filterParam = ''

    for (const prop in filters) {
      if (filters[prop]) {
        filterParam += `&filter[${prop}]=${filters[prop]}`
      }
    }

    const url = `products-collections?filter[category.slug]=${categorySlug}${filterParam}${sortParam}`
    const api = useApi()

    try {
      return await api.makeRequest(url, 'get')
    } catch (err) {
      throw err
    }
  },

  async getHomeFeatured(categories = [2, 3, 4, 5], limit = 10, sort = 'collection') {
    const url = `products?filter[featured]=1&filter[categories]=${categories.join(',')}&sort=${sort}&limit=${limit}`
    const api = useApi()

    try {
      return await api.makeRequest(url, 'get')
    } catch (err) {
      throw err
    }
  },

  async getHomePromotions() {
    const url = `products?filter[featured]=1&filter[categories]=11&sort=collection`
    const api = useApi()

    try {
      return await api.makeRequest(url, 'get')
    } catch (err) {
      throw err
    }
  },

  async getListByIds(ids, sorts = '') {
    const sortParam = sorts ? `&sort=${sorts}` : ''
    const url = `products?filter[id]=${ids.join(",")}${sortParam}`
    const api = useApi()

    try {
      return await api.makeRequest(url, 'get')
    } catch (err) {
      throw err
    }
  },

  async getCalendarByCategoriesSlug(categorySlugs, sorts = '') {
    const sortParam = sorts ? `&sort=${sorts}` : ''
    const url = `products?filter[category.slug]=${categorySlugs}&filter[calendarized]=1${sortParam}`
    const api = useApi()

    try {
      return await api.makeRequest(url, 'get')
    } catch (err) {
      throw err
    }
  },

  async search(query, sorts = '', filters = {}) {
    let sortParam = sorts ? `&sort=${sorts}` : ''
    let filterParam = ''

    for (const prop in filters) {
      if (filters[prop]) {
        filterParam += `&filter[${prop}]=${filters[prop]}`
      }
    }
    const url = `searchs?query=${query}${sortParam}${filterParam}`
    const api = useApi()

    try {
      return await api.makeRequest(url, 'get')
    } catch (err) {
      throw err
    }
  }
})
